import declinedCustomer from '../../assets/declinedCustomer.svg';
import { CustomerRow } from '../../CustomersV2.types';
import { getProfileTitle } from '../CustomerProfileModal/profileStages';
import { InfoSheet } from '../InfoSheet/InfoSheet';

export const DeclinedCustomerModal = ({
  row,
  onClose,
}: {
  row: CustomerRow | null;
  onClose: () => void;
}) => {
  if (!row) return null;

  return (
    <InfoSheet
      isOpen
      onClose={onClose}
      title={getProfileTitle(row)}
      closeLabel="Close declined customer"
    >
      <div className="flex flex-col items-center gap-2xl px-xl py-2xl">
        <img
          src={declinedCustomer}
          alt=""
          // The SVG's only intrinsic size is its 384x322 viewBox.
          className="w-[384px] max-w-full"
        />
        <div className="text-xl font-bold text-primary-10">
          This customer was declined.
        </div>
      </div>
    </InfoSheet>
  );
};
